/*
 * @Author: 周泽飞 zefei.zhou@tongdun.net
 * @Date: 2023-03-08 16:45:46
 * @LastEditors: 周泽飞 zefei.zhou@tongdun.net
 * @LastEditTime: 2023-03-08 18:33:42
 * @FilePath: /tntd/packages/tntd/src/modal/index.ts
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
// import Modal from 'antd/lib/modal'
import 'antd/lib/modal/style'
import { Modal } from './modal'

import './modal.less'

export * from './modal'

export default Modal
